<dx-toolbar class="theme-dependent">
    <dxi-item location="before">
        <div class="header-text">{{ number ? 'Edit' : 'New' }}</div>
    </dxi-item>
    <dxi-item location="after" locateInMenu="never" [visible]="canExport">
        <dx-button text="Export" stylingMode="outlined" type="normal" [disabled]="isExporting"
            (onClick)="exportClick.emit()" class="ms-2" />
    </dxi-item>
    <dxi-item location="after" locateInMenu="never">
        <dx-button text="Cancel" stylingMode="outlined" type="normal" (onClick)="cancelClick.emit()" class="ms-2" />
    </dxi-item>
    <dxi-item location="after" locateInMenu="never" [visible]="canShowButton(CreditRequestAction.SaveAsDraft)">
        <dx-button text="Save As Draft" type="default" stylingMode="contained" [disabled]="isSubmitting"
            (onClick)="onButtonClick(CreditRequestAction.SaveAsDraft)" class="ms-2" />
    </dxi-item>
    <dxi-item location="after" locateInMenu="never" [visible]="canShowButton(CreditRequestAction.Save)">
        <dx-button text="Save" type="default" stylingMode="contained" [disabled]="isSubmitting"
            (onClick)="onButtonClick(CreditRequestAction.Save)" class="ms-2" />
    </dxi-item>
    <dxi-item location="after" locateInMenu="never" [visible]="canShowButton(CreditRequestAction.Submit)">
        <dx-button text="Submit" type="success" stylingMode="contained" [disabled]="isSubmitting"
            (onClick)="onButtonClick(CreditRequestAction.Submit)" class="ms-2" />
    </dxi-item>
    <dxi-item location="after" locateInMenu="never" [visible]="canShowButton(CreditRequestAction.Complete)">
        <dx-button text="Complete" type="success" stylingMode="contained" [disabled]="isSubmitting"
            (onClick)="onButtonClick(CreditRequestAction.Complete)" class="ms-2" />
    </dxi-item>
    <dxi-item location="after" locateInMenu="never" [visible]="canShowButton(CreditRequestAction.BackToAP)">
        <dx-button text="Back to AP" type="danger" stylingMode="contained" [disabled]="isSubmitting"
            (onClick)="onButtonClick(CreditRequestAction.BackToAP)" class="ms-2" />
    </dxi-item>
    <dxi-item location="after" locateInMenu="never" [visible]="showMoreMenu">
        <dx-drop-down-button text="More" icon="overflow" [dropDownOptions]="{ width: 210 }" [items]="moreMenuActions"
            [splitButton]="false" stylingMode="outlined" type="default" displayExpr="text" keyExpr="id"
            [disabled]="isSubmitting" (onItemClick)="onMenuActionClick($event)" class="ms-2">
        </dx-drop-down-button>
    </dxi-item>
</dx-toolbar>